import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=d10b2f5c&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=d10b2f5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10b2f5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d10b2f5c')) {
      api.createRecord('d10b2f5c', component.options)
    } else {
      api.reload('d10b2f5c', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=d10b2f5c&scoped=true&", function () {
      api.rerender('d10b2f5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22itpyHuXCIkA/JS/comp/PopupDialog.vue"
export default component.exports